import { RelayServerTransport } from '~/modules/remote-mic/network/server/transport/relay-server-transport';

export const WEBSOCKETS_SERVER = import.meta.env.VITE_APP_WEBSOCKET_URL;

export class WebSocketServerTransport extends RelayServerTransport {
  public readonly name = 'WebSockets';

  // The room is named in the `register-room` message rather than in the URL, so every room on this
  // relay dials the same address.
  protected getUrl = (_roomId: string) => WEBSOCKETS_SERVER;
}
